export const setupCookie = () => {
    const utmKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content'];
    const referralKeys = ['r'];
    const referralCookieName = 'ref';
    const tikTokClickId = 'ttclid';

    function keys(objects: Record<string, string>) {
        return Object.keys(objects);
    }

    function setCookie(name: string, value: string, expires?: number) {
        if (name && value) {
            const expiration = expires || 365;

            document.cookie = `${name}=v=${value}&ts=${new Date().getTime()}; expires=${new Date(
                new Date().getTime() + expiration * 24 * 60 * 60 * 1000,
            ).toUTCString()}; path=/; domain=kashable.com`;
        }
    }

    function setCookies(obj: Record<string, string>, keys: string[]) {
        keys.forEach((key) => {
            setCookie(key, obj[key]);
        });
    }

    function deleteCookie(name: string) {
        if (name) {
            document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=kashable.com`;
        }
    }

    function deleteCookies(names: string[]) {
        names.forEach((name) => {
            deleteCookie(name);
        });
    }

    function getUrlParams(exclude: string[]) {
        const params: Record<string, string> = {};

        window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, (m, key, value) => {
            if (value && exclude.indexOf(key) === -1) {
                params[key] = value;
            }

            return m;
        });

        return params;
    }

    function hasParam(urlParams: Record<string, string>, options: string[]) {
        for (let i = 0; i < options.length; i++) {
            if (typeof urlParams[options[i]] !== 'undefined') {
                return true;
            }
        }

        return false;
    }

    function utmWorkflow() {
        const urlParams = getUrlParams(referralKeys);
        const urlParamsKeys = keys(urlParams);

        if (hasParam(urlParams, utmKeys)) {
            deleteCookies(utmKeys);
        }

        setCookies(urlParams, urlParamsKeys);
    }

    function referralCode() {
        const urlParams = getUrlParams(utmKeys);

        if (hasParam(urlParams, ['r'])) {
            setCookie(referralCookieName, urlParams['r'], 180);
        }
    }

    function tiktokFlow() {
        const urlParams = getUrlParams([]);

        if (hasParam(urlParams, [tikTokClickId])) {
            setCookie(tikTokClickId, urlParams[tikTokClickId]);
        }
    }

    utmWorkflow();
    referralCode();
    tiktokFlow();
};
